export const GET_TEMPLATE = "GET_TEMPLATE";
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS";
export const GET_TEMPLATE_FAILURE = "GET_TEMPLATE_FAILURE";

export const GET_ALL_TEMPLATE = "GET_ALL_TEMPLATE";
export const GET_ALL_TEMPLATE_SUCCESS = "GET_ALL_TEMPLATE_SUCCESS";
export const GET_ALL_TEMPLATE_FAILURE = "GET_ALL_TEMPLATE_FAILURE";

export const RESET_TEMPLATE = "RESET_TEMPLATE";

export interface TemplateState {
  templateList: any;
  templateData: any;
  templateSuccess: string | null;
  templateError: string | null;
  templateLoading: boolean;
}

interface GetTemplateAction {
  type: typeof GET_TEMPLATE;
  payload: any;
}

interface GetTemplateSucess {
  type: typeof GET_TEMPLATE_SUCCESS;
  payload: any;
}

interface GetTemplateFailure {
  type: typeof GET_TEMPLATE_FAILURE;
  payload: string;
}

interface GetAllTemplateAction {
  type: typeof GET_ALL_TEMPLATE;
  payload: any;
}

interface GetAllTemplateSucess {
  type: typeof GET_ALL_TEMPLATE_FAILURE;
  payload: any;
}

interface GetAllTemplateFailure {
  type: typeof GET_ALL_TEMPLATE_FAILURE;
  payload: string;
}

interface ResetTemplateAction {
  type: typeof RESET_TEMPLATE;
}

export type TemplateActionTypes =
  | GetAllTemplateAction
  | GetAllTemplateSucess
  | GetAllTemplateFailure
  | GetTemplateAction
  | GetTemplateSucess
  | GetTemplateFailure
  | ResetTemplateAction;
